import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { types } from '@/modules/pujcovna/planovanaPujcka/store/types';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		PujcovnaId: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		PujckaDatOd: null as string | null,
		PujckaDatDo: null as string | null,
		PujcpaStatus: null as boolean | null,
		VyrazenPrp: null as boolean | null,
		PujcovnaId: null as number | null,
		VozidlopaId: null as number | null,
		ZakaznikId: null as number | null,
		VozidloRzv: null as string | null,
		VozidloVin: null as string | null,
		ZakaznikIdText: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.PLANOVANA_PUJCKA_FILTER_VOZIDLO](state, { data }) {
			state.filter.VozidlopaId = data.id;
			state.filter.VozidloRzv = data.rzv;
			state.filter.VozidloVin = data.vin;
		},
		[types.mutations.PLANOVANA_PUJCKA_FILTER_ZAKAZNIK](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
